"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = attackSpeedToString;

function attackSpeedToString(attackSpeed) {
  // TODO: i18n
  if (attackSpeed <= 1500) return "Fast +2";
  if (attackSpeed <= 1700) return "Fast +1";
  if (attackSpeed <= 1900) return "Fast";
  if (attackSpeed <= 2100) return "Medium";
  if (attackSpeed <= 2300) return "Slow";
  if (attackSpeed <= 2500) return "Slow +1";
  return "Slow +2";
}